module.exports = __webpack_public_path__ + "img/1652.2c391b2c.jpg";